import { Link } from 'react-router-dom'

import { layoutCopy } from '../content/layout'
import { PAGES, type Lang } from '../i18n'
import LangToggle from './LangToggle'
import Wordmark from './Wordmark'
import styles from './Header.module.css'

/**
 * The first three nav items are sections of the home page, so they are real URLs with a
 * fragment rather than scroll handlers. RootLayout does the scrolling when the hash
 * changes, which keeps them working from the prose pages as well. Contact and What's new
 * are pages in their own right and are plain links.
 */
export default function Header({ lang }: { lang: Lang }) {
  const t = layoutCopy[lang]
  const home = PAGES.home[lang]

  return (
    <header className={styles.header}>
      <div className={`container ${styles.inner}`}>
        <Link to={home} className={styles.brand}>
          <Wordmark />
        </Link>

        <nav className={styles.nav} aria-label={lang === 'sv' ? 'Huvudmeny' : 'Main'}>
          <Link to={home} className={styles.navLink}>
            {t.navHome}
          </Link>
          <Link to={`${home}#features`} className={styles.navLink}>
            {t.navFeatures}
          </Link>
          <Link to={`${home}#about`} className={styles.navLink}>
            {t.navAbout}
          </Link>
          {/* The two nav items that are pages of their own rather than sections. */}
          <Link to={PAGES.contact[lang]} className={styles.navLink}>
            {t.navContact}
          </Link>
          <Link to={PAGES.news[lang]} className={styles.navLink}>
            {t.navNews}
          </Link>
          <span className={styles.langWrap}>
            <LangToggle current={lang} />
          </span>
        </nav>
      </div>
    </header>
  )
}
